/**
 * Shared design tokens & images.
 */
export const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_991bf69f-d16c-44d1-818a-ae15d667356c/artifacts/sw9ykpsk_Gemini_Generated_Image_w0lf80w0lf80w0lf.jpg";

export const BOOK_MOCKUP =
  "https://customer-assets.emergentagent.com/job_affiliate-hub-553/artifacts/91vc7rb5_book_11.JPG";

export const TESTIMONIAL_AVATARS = {
  omer: "https://images.unsplash.com/photo-1761773916036-259709de5c2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxtZWRpdGVycmFuZWFuJTIwbWFuJTIwc21pbGluZyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTY4NTEwM3ww&ixlib=rb-4.1.0&q=85",
  rona: "https://images.unsplash.com/photo-1530110381246-67c75e707090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxtZWRpdGVycmFuZWFuJTIwd29tYW4lMjBzbWlsaW5nJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgxNjg1MTAzfDA&ixlib=rb-4.1.0&q=85",
};

export const COMMUNITY_MOCKUP =
  "https://images.unsplash.com/photo-1592890288564-76628a30a657?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwZ3JvdXAlMjBjaGF0JTIwaGFuZHxlbnwwfHx8fDE3ODE2ODUxMDN8MA&ixlib=rb-4.1.0&q=85";

export const ATMOSPHERE_BG =
  "https://images.unsplash.com/photo-1649209979970-f01d950cc5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjYWxjdWxhdG9yJTIwbm90ZWJvb2slMjBwZW4lMjBkZXNrfGVufDB8fHx8MTc4MTY4NTEwM3ww&ixlib=rb-4.1.0&q=85";
